import { httpClientBot, httpPlainBotApi, httpClientOmni } from "@/libraries";
import agentStore from "../omni-messaging/agent.store";
// import { url } from "vuelidate/lib/validators";
// import { fi } from "element-plus/es/locale";

const state = {
  loading: false,
  assistant: null,
  agentStore: agentStore,
  function_tools: [],
  knowledge_source: {
    url: [],
    file: [],
  },
  listAssistant: [],
  listAgentic: [],
  files: [],
  playground: [],
  vectorFiles: [],
  assistantMessage: false,
  models: [],
  vector: [],
  summary: [],
  summary_last_period: [],
  active_user: [],
  top_active_user: [],
  message_sent: [],
  message_categories: [],
  top_categories: [],
  conversation_session: [],
};

const getters = {
  loading(state) {
    return state.loading;
  },
  assistant(state) {
    return state.listAssistant;
  },
  agentic(state) {
    return state.listAgentic;
  },
  assistantById(state) {
    return state.assistant;
  },
  files(state) {
    return state.files;
  },
  playground(state) {
    return state.playground;
  },
  vector(state) {
    return state.vector;
  },
  vectorFiles(state) {
    return state.vectorFiles;
  },
  assistantMessage(state) {
    return state.assistantMessage;
  },
  threadUnique(state) {
    return state.thread_unique;
  },
  getModels(state) {
    return state.models;
  },
  getSummary(state) {
    return state.summary;
  },
  getSummaryLastPeriod(state) {
    return state.summary_last_period;
  },
  getActiveUser(state) {
    return state.active_user;
  },
  getTopActiveUser(state) {
    return state.top_active_user;
  },
  getMessageSent(state) {
    return state.message_sent;
  },
  getMessageRequest(state) {
    return state.message_sent;
  },
  getTopCategories(state) {
    return state.top_categories;
  },
  getMessageCategories(state) {
    return state.message_categories;
  },
  agentStore(state) {
    return state.agentStore;
  },
  functionTools(state) {
    return state.function_tools;
  },
  knowledgeSourceUrl(state) {
    return state.knowledge_source.url;
  },
  knowledgeSourceFile(state) {
    return state.knowledge_source.file;
  },
};

const mutations = {
  SET_LOADING(state, data) {
    state.loading = data;
  },
  SET_ASSISTANT(state, data) {
    state.listAssistant = data;
  },
  SET_AGENTIC(state, data) {
    state.listAgentic = data;
  },
  SET_AGENT_STORE(state, data) {
    state.agentStore = data;
  },
  SET_FUNCTION_TOOLS(state, data) {
    state.function_tools = data;
  },
  SET_KNOWLEDGE_SOURCE(state, data) {
    console.log("Knowledge Source Data:", data);
    // Group data by type
    let groupedData = {
      url: [],
      file: [],
    };
    data = data.reduce((acc, item) => {
      if (!item.type) return acc;
      if (!acc[item.type]) {
        acc[item.type] = [];
      }
      // Gabungkan tipe 'single-url' dan 'url' ke dalam satu grup 'url'
      if (item.type === "single-url" || item.type === "url") {
        groupedData.url.push(item);
      } else {
        groupedData.file.push(item);
      }
      return acc;
    }, {});

    state.knowledge_source.url = groupedData.url;
    state.knowledge_source.file = groupedData.file;
  },
  SET_ASSISTANT_BY_ID(state, data) {
    state.assistant = data;
  },
  SET_FILES(state, data) {
    state.files = data;
  },
  ADD_PLAYGROUND(state, data) {
    state.playground.push(data);
  },
  CLEAR_PLAYGROUND(state) {
    state.playground = [];
  },
  MOD_PLAYGROUND(state, data) {
    state.playground[state.playground.length - 1].message += data;
  },
  SET_VECTOR(state, data) {
    state.vector = data;
  },
  SET_VECTORFILES(state, data) {
    state.vectorFiles = data;
  },
  SET_ASSISTANT_MESSAGE(state, data) {
    state.assistantMessage = data;
  },
  SET_MODELS(state, data) {
    state.models = data;
  },
  SET_THREAD_UNIQUE(state, data) {
    state.thread_unique = data;
  },
  SET_SUMMARY(state, data) {
    state.summary = data;
  },
  SET_SUMMARY_LAST_PERIOD(state, data) {
    state.summary_last_period = data;
  },
  SET_ACTIVE_USER(state, data) {
    state.active_user = data;
  },
  SET_TOP_ACTIVE_USER(state, data) {
    state.top_active_user = data;
  },
  SET_MESSAGE_SENT(state, data) {
    state.message_sent = data;
  },
  SET_TOP_CATEGORIES(state, data) {
    state.top_categories = data;
  },
  SET_MESSAGE_CATEGORIES(state, data) {
    state.message_categories = data;
  },
  SET_CONVERSATION_SESSION(state, data) {
    state.conversation_session = data;
  },
};

const actions = {
  async listAssistant({ commit, rootGetters }) {
    const resp = await httpPlainBotApi.get(
      rootGetters.appId.hashed + "/assistant"
    );
    // console.log(resp.data.data.data);
    commit("SET_ASSISTANT", resp.data.data);
    return resp.data.data;
  },
  async create({ rootGetters }, payload) {
    const resp = httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/assistant",
      payload
    );
    return resp;
  },
  async getById({ rootGetters }, id) {
    const resp = await httpPlainBotApi.get(
      "/" + rootGetters.appId.hashed + "/assistant/detail/" + id
    );
    return resp.data.data;
  },
  async update({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.put(
      "/" + rootGetters.appId.hashed + "/assistant/" + payload.id,
      payload
    );
    return resp.data.data;
  },
  async delete({ rootGetters }, id) {
    const resp = await httpPlainBotApi.delete(
      "/" + rootGetters.appId.hashed + "/assistant/" + id
    );
    console.log(resp);
  },
  async getFile({ rootGetters, commit }, params = null) {
    let type = "";
    if (params) {
      if (params.type) {
        type = `?type=${params.type}`;
      }
    }
    const resp = await httpPlainBotApi.get(
      "/" + rootGetters.appId.hashed + "/assistant/file" + type
    );
    commit("SET_FILES", resp.data.data);
  },
  async uploadFile({ rootGetters, commit }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/assistant/file",
      payload
    );
    console.log(resp);
    return resp.data;
  },
  async deleteFile({ rootGetters, commit }, id) {
    const resp = httpPlainBotApi.delete(
      "/" + rootGetters.appId.hashed + "/assistant/file/" + id
    );
    console.log(resp);
  },
  async attach({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/assistant/attach-file",
      payload
    );
    console.log(resp);
  },
  async detach({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/assistant/detach-file",
      payload
    );
    console.log(resp);
    return resp.data;
  },
  async sendPlayground({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/assistant/playground/send",
      payload
    );
    return resp.data.data;
  },
  async sendPlaygroundNew({ rootGetters }, payload) {
    console.log("Payload di action sendPlaygroundNew:", payload);
    const resp = await httpClientOmni.post(
      "/agent-ai/" + payload.assistant_id + "/playground",
      payload
    );
    return resp.data.data;
  },
  clearPlayground({ commit }) {
    commit("CLEAR_PLAYGROUND");
  },
  async createVector({ rootGetters }, payload) {
    await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/vector-store",
      payload
    );
  },
  async getvectorFile({ rootGetters, commit }) {
    const resp = await httpPlainBotApi.get(
      "/" + rootGetters.appId.hashed + "/vector-store"
    );
    commit("SET_VECTORFILES", resp.data.data);
  },
  async deletevectorFile({ rootGetters, commit }, id) {
    const resp = httpPlainBotApi.delete(
      "/" + rootGetters.appId.hashed + "/vector-store/" + id
    );
    console.log(resp);
  },
  async attachfileVector({ rootGetters, commit }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/vector/" + payload.id,
      {
        file: payload.file,
        assistant_id: payload.assistant_id,
      }
    );

    commit("SET_VECTOR", resp.data);
    return resp.data;
  },
  async detachfileVector({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/vector/" + payload.id + "/detach",
      {
        file: payload.file,
        assistant_id: payload.assistant_id,
      }
    );
    return resp;
  },
  async updateVectorName({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.put(
      "/" + rootGetters.appId.hashed + "/vector-store/" + payload.id.id,
      { name: payload.name }
    );
    console.log(resp);
  },
  async crawl({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/nlp/crawl",
      { url: payload.url }
    );
    return resp;
  },
  async scrape({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/nlp/scrape-v2",
      payload
    );
    console.log(resp);
    return resp;
  },

  async scrapUrl({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      `/${rootGetters.appId.hashed}/agent-ai/${payload.id}/scrap`,
      payload
    );
    console.log(resp);
    return resp;
  },
  async generatePrompt(_, payload) {
    const resp = await httpClientBot.post("/assistant/prompt", payload);
    return resp.data;
  },
  async exportLogs({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/bot/logs/export",
      payload
    );
    return resp;
  },
  async getModels({ rootGetters, commit }) {
    const resp = await httpPlainBotApi.get(
      "/" + rootGetters.appId.hashed + "/model"
    );
    commit("SET_MODELS", resp.data.data);
    return resp.data.data;
  },
  async getSummary({ rootGetters, commit }, payload) {
    let filterDate = "";
    let assistantId = "";
    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/dashboard/summary${filterDate}${assistantId}`
    );

    commit("SET_SUMMARY", resp.data.data);

    return resp.data.data;
  },
  async getActiveUser({ rootGetters, commit }, payload = null) {
    let filterDate = "";
    let assistantId = "";
    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/dashboard/active-user${filterDate}${assistantId}`
    );
    commit("SET_ACTIVE_USER", resp.data.data);

    return resp.data.data;
  },

  async getTopActiveUser({ rootGetters, commit }, payload = null) {
    let filterDate = "";
    let assistantId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/dashboard/top-active-users${filterDate}${assistantId}`
    );

    commit("SET_TOP_ACTIVE_USER", resp.data.data);

    return resp.data.data;
  },
  async getMessageSent({ rootGetters, commit }, payload = null) {
    let filterDate = "";
    let assistantId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/dashboard/message-sent${filterDate}${assistantId}`
    );

    commit("SET_MESSAGE_SENT", resp.data.data);

    return resp.data.data;
  },
  async getTopCategories({ rootGetters, commit }, payload = null) {
    let filterDate = "";
    let assistantId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/dashboard/category${filterDate}${assistantId}`
    );
    commit("SET_TOP_CATEGORIES", resp.data.data);

    return resp.data.data;
  },

  async exportSummary({ rootGetters }, payload = null) {
    let filterDate = "";
    let assistantId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/dashboard/summary/export${filterDate}${assistantId}`
    );

    return resp.data;
  },

  async exportCategory({ rootGetters }, payload = null) {
    let filterDate = "";
    let assistantId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/dashboard/category/export${filterDate}${assistantId}`
    );

    return resp.data;
  },
  threadUnique(payload) {
    commit("SET_THREAD_UNIQUE", payload);
  },

  // Agent AI related actions
  async createAgentAi({ rootGetters }, payload) {
    const resp = httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/agent-ai",
      payload
    );
    return resp;
  },

  async getAgentAiById({ rootGetters }, id) {
    const resp = await httpPlainBotApi.get(
      "/" + rootGetters.appId.hashed + "/agent-ai/" + id
    );
    return resp.data.data;
  },

  async modifyAgentAi({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.put(
      "/" + rootGetters.appId.hashed + "/agent-ai/" + payload.id,
      payload
    );
    return resp.data.data;
  },

  async deleteAgentAi({ rootGetters }, id) {
    const resp = await httpPlainBotApi.delete(
      "/" + rootGetters.appId.hashed + "/agent-ai/" + id
    );
    console.log(resp);
  },

  async listAgentAi({ commit, rootGetters }) {
    const resp = await httpPlainBotApi.get(
      rootGetters.appId.hashed + "/agent-ai?limit=1000&offset=0"
    );
    // console.log(resp.data.data.data);
    commit("SET_AGENT_STORE", resp.data.data);
    return resp.data.data;
  },

  async listFunctionTools({ commit, rootGetters }, id) {
    commit("SET_LOADING", true);
    const resp = await httpPlainBotApi.get(
      "/" + rootGetters.appId.hashed + "/agent-ai/" + id + "/function"
    );
    commit("SET_FUNCTION_TOOLS", resp.data.data);
    commit("SET_LOADING", false);

    return resp.data.data;
  },

  async createFunctionTools({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.post(
      "/" + rootGetters.appId.hashed + "/agent-ai/" + payload.id + "/function",
      payload.data
    );

    await this.dispatch("gen-ai/listFunctionTools", payload.id);

    return resp.data.data;
  },

  async updateFunctionTools({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.put(
      "/" +
        rootGetters.appId.hashed +
        "/agent-ai/" +
        payload.id +
        "/function" +
        "/" +
        payload.function_id,
      payload.data
    );

    await this.dispatch("gen-ai/listFunctionTools", payload.id);

    return resp.data.data;
  },

  async deleteFunctionTools({ rootGetters }, payload) {
    const resp = await httpPlainBotApi.delete(
      "/" +
        rootGetters.appId.hashed +
        "/agent-ai/" +
        payload.id +
        "/function" +
        "/" +
        payload.function_id
    );

    await this.dispatch("gen-ai/listFunctionTools", payload.id);

    return resp.data.data;
  },

  async getKnowledgeSource({ commit, rootGetters }, id) {
    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/agent-ai/${id}/files`
    );

    commit("SET_KNOWLEDGE_SOURCE", resp.data.data);

    return resp.data.data;
  },

  async deleteKnowledgeSource({ commit, rootGetters }, payload) {
    const resp = await httpPlainBotApi.delete(
      `/${rootGetters.appId.hashed}/agent-ai/${payload.assistantId}/files/${payload.fileId}`
    );

    await this.dispatch("gen-ai/getKnowledgeSource", payload.assistantId);
    return resp.data.data;
  },

  async uploadFileAgentAi({ commit, rootGetters }, payload) {
    commit("SET_LOADING", true);
    try {
      const resp = await httpPlainBotApi.post(
        `/${rootGetters.appId.hashed}/agent-ai/${payload.id}/files/queue`,
        payload.data
      );

      await this.dispatch("gen-ai/getKnowledgeSource", payload.id);
      return resp.data;
    } catch (error) {
      console.log("Error uploading file:", error);
    }
    commit("SET_LOADING", false);
  },

  async getActiveUserAgentAi({ rootGetters, commit }, payload = null) {
    let filterDate = "";
    let assistantId = "";
    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/agent-ai/dashboard/active-user${filterDate}${assistantId}`
    );
    commit("SET_ACTIVE_USER", resp.data.data);

    return resp.data.data;
  },

  async getTopActiveUserAgentAi({ rootGetters, commit }, payload = null) {
    let filterDate = "";
    let assistantId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/agent-ai/dashboard/top-active-user${filterDate}${assistantId}`
    );

    commit("SET_TOP_ACTIVE_USER", resp.data.data);

    return resp.data.data;
  },

  async getMessageRequest({ rootGetters, commit }, payload = null) {
    let filterDate = "";
    let assistantId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        assistantId = `?assistant=${payload.assistant_id}`;
      } else {
        assistantId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/agent-ai/dashboard/message-requests${filterDate}${assistantId}`
    );

    commit("SET_MESSAGE_SENT", resp.data.data);

    return resp.data.data;
  },

  async exportAgentAiLog({ rootGetters }, payload) {
    try {
      let params = "";
      console.log("Exporting logs with payload:", payload);
      if (payload && payload.date_from && payload.date_to) {
        params += `?date_from=${payload.date_from}&date_to=${payload.date_to}`;
      }
      if (payload && payload.search) {
        params += params
          ? `&search=${payload.search}`
          : `?search=${payload.search}`;
      }
      if (payload && payload.status) {
        params += params
          ? `&status=${payload.status}`
          : `?status=${payload.status}`;
      }
      if (payload && payload.channel) {
        params += params
          ? `&channel=${payload.channel}`
          : `?channel=${payload.channel}`;
      }
      console.log("Exporting logs with params:", params);
      let response = await httpPlainBotApi.get(
        `/${rootGetters.appId.hashed}/agent-ai/log/export${params}`,
        { responseType: "blob" }
      );
      return response;
    } catch (error) {
      console.error("Error exporting logs:", error);
    }
  },

  async getAgentAiSummary({ commit, rootGetters }, payload) {
    let filterDate = "";
    let agenticId = "";
    if (payload) {
      if (payload.date_from && payload.date_to) {
        filterDate = `?startDate=${payload.date_from}&endDate=${payload.date_to}`;
      }

      if (payload.assistant_id) {
        if (!payload.date_from) {
          agenticId = `?assistant=${payload.assistant_id}`;
        } else {
          agenticId = `&assistant=${payload.assistant_id}`;
        }
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/agent-ai/dashboard/summary${filterDate}${agenticId}`
    );

    commit("SET_SUMMARY", resp.data.data);
    return resp.data.data;
  },

  async getAgentAiSummaryLastPeriod({ commit, rootGetters }, payload) {
    let filterDate = "";
    let agenticId = "";
    if (payload) {
      if (payload.date_from && payload.date_to) {
        filterDate = `?startDate=${payload.date_from}&endDate=${payload.date_to}`;
      }

      if (payload.assistant_id) {
        if (!payload.date_from) {
          agenticId = `?assistant=${payload.assistant_id}`;
        } else {
          agenticId = `&assistant=${payload.assistant_id}`;
        }
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/agent-ai/dashboard/summary-last-period${filterDate}${agenticId}`
    );

    commit("SET_SUMMARY_LAST_PERIOD", resp.data.data);
    return resp.data.data;
  },

  async getMessageCategories({ commit, rootGetters }, payload) {
    let filterDate = "";
    let agenticId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        agenticId = `?assistant=${payload.assistant_id}`;
      } else {
        agenticId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/agent-ai/dashboard/top-message-categories${filterDate}${agenticId}`
    );

    commit("SET_MESSAGE_CATEGORIES", resp.data.data);
    return resp.data.data;
  },

  async getConversationSession({ commit, rootGetters }, payload) {
    let filterDate = "";
    let agenticId = "";

    if (payload.startDate) {
      filterDate = `?startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    if (payload.assistant_id) {
      if (!payload.startDate) {
        agenticId = `?assistant=${payload.assistant_id}`;
      } else {
        agenticId = `&assistant=${payload.assistant_id}`;
      }
    }

    const resp = await httpPlainBotApi.get(
      `/${rootGetters.appId.hashed}/agent-ai/dashboard/conversation-session${filterDate}${agenticId}`
    );

    commit("SET_COVERSATION_SESSION", resp.data.data);
    return resp.data.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
